var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.showReloadIndex)?_c('router-view',{key:_setup.fullPath}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }